import styled from 'styled-components';


export const BadgeBanner = styled.div`
    @media screen and (max-width: 1024px){
        padding-top: 50px;
    }

    @media screen and (max-width: 767px){
        padding-top: 114px;
    }

    .left_banner {
        padding-left: 0px;
    }
    .great-non-profits-title{
        max-width:inherit;
    }
    .text-great{
            max-width:inherit;
        }
    .strong-txt{
        padding-bottom: 20px;
        display: block;
    }

    .great-nonprofits-badge-banner{
        
        @media screen and (max-width: 991px){
            padding-top: 120px;
        }

        @media screen and (max-width: 575px){
            padding-top: 50px;
        }
    }

    .left_banner{
        @media screen and (max-width: 1024px){
            margin-bottom: 0;
        }
    }
`;

export const TopRatedBadge = styled.div`
  background: #F1FEFF 0% 0% no-repeat padding-box;
  padding:50px 0;

  @media screen and (max-width: 575px){
    padding: 40px 0;
  }
`;

export const RatedBadgeWrapper = styled.div`
    display: flex;
    gap:35px;
    padding-bottom: 50px;

    @media screen and (max-width: 991px){
        flex-direction: column;
        row-gap: 30px;
    }

    @media screen and (max-width: 575px){
        padding-bottom: 40px;
    }
`;

export const RatedBadgeLeft = styled.div`
  width:100%;
  max-width:772px;

  .btn-outline-success-blue{
    min-width: 324px;
    padding: 12px 20px;
    box-shadow: 3px 5px 20px #00000033;
    margin-top: 30px;

    @media screen and (max-width: 767px){
        margin-top: 20px;
    }

    @media screen and (max-width: 575px){
        min-width: max-content;
    }
    
}
`;
export const RatedBadgeRight = styled.div`
   width:100%;
   max-width:393px;
   background: #FFFFFF 0% 0% no-repeat padding-box;
    box-shadow: 0px 20px 20px #0000001A;
    border-radius: 20px;
    padding:50px 27px;

    @media screen and (max-width: 991px){
        max-width: 100%;
        text-align: center;
        padding: 30px;
    }

    img{
        width:100%;

        @media screen and (max-width: 991px){
            max-width: 350px;
        }
    }
`;

export const RatedTitle = styled.h2`
    color: #333333;
    font-family: "Jost", sans-serif;
    font-size:30px;
    font-weight:700;
    line-height: 43px;
    margin-bottom: 20px;

    @media screen and (max-width: 991px){
        font-size:28px;
        line-height: 40px;
        margin-bottom: 15px;
    }
    @media screen and (max-width: 767px){
        font-size:26px;
        line-height: 38px;
    }

    @media screen and (max-width: 575px){
        margin-bottom: 10px;
    }

    &:last-child{
        margin-bottom: 0px;
    }
`;

export const RatedText = styled.p`
color: #333333;
font-family: "Jost", sans-serif;
font-size:18px;
font-weight: 500;
line-height: 27px;
margin-bottom: 23px;

@media screen and (max-width: 767px){
    font-size:16px;
    line-height: 24px;
    margin-bottom: 15px;
}
strong{
    font-weight: 700;
}
span{
    color:#01606F;
    font-weight: 700;
}

`;

export const StatisticsSection = styled.div`

`;

export const StatisticsLeft = styled.div`
    background: #FFFFFF 0% 0% no-repeat padding-box;
    border-radius: 15px;
    padding: 30px;
    width: 50%; 

    @media screen and (max-width: 1200px){
        padding: 20px;
    }

    @media screen and (max-width: 991px){
        width: 100%; 
    }

    @media screen and (max-width: 575px){
        padding: 15px;
    }

    img{
        width: 100%;
        display: block;
    }
`;

export const StatisticsRight = styled.div`
    background: #FFFFFF 0% 0% no-repeat padding-box;
    border-radius: 15px;
    padding: 30px;
    width: 50%; 
    
    @media screen and (max-width: 1200px){
        padding: 20px;
    }

    @media screen and (max-width: 991px){
        width: 100%; 
    }

    img{
        width: 100%;
        display: block;
    }
`;
export const StatisticsWrapper = styled.div`
    display: flex;
    align-items: center;
    gap: 24px;

    @media screen and (max-width: 991px){
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
    }

`;

export const StatisticsTitle = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
    padding-bottom: 20px;

    @media screen and (max-width: 575px){
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        padding-bottom: 10px;
    }


`;
export const AmountCol = styled.h3`
    color: #333333;
    font-family: "Jost", sans-serif;
    font-size:48px;
    font-weight: 600;
    line-height:69px;

    @media screen and (max-width: 1200px){
        font-size:46px;
        line-height:66px;
    }

    @media screen and (max-width: 991px){
        font-size:40px;
        line-height:60px;
    }

    @media screen and (max-width: 767px){
        font-size:36px;
        line-height:56px;
    }

    @media screen and (max-width: 575px){
        font-size:32px;
        line-height:52px;
    }

`;
export const StatisticsText = styled.p`
    color: #333333;
    font-family: "Jost", sans-serif;
    font-size:18px;
    font-weight:500;
    line-height: 27px;
    margin-bottom: 0px;

`;
